<div class="root-body"
     data-testid="settings-all-users"
     [ngClass]="{
    'root-body-sidebar-slim': configService.config.menuMode === 'sidebar' || configService.config.menuMode === 'slim',
    'root-body-sidebar-static': configService.config.menuMode === 'sidebar' && configService.config.sidebarStatic,
    'root-body-horizontal': configService.config.menuMode === 'horizontal'}">

    <p-breadcrumb class="breadcrumb mb-3" [model]="breadcrumbs"></p-breadcrumb>

    <div class="card">
        <p-table #usersGrid
                 [columns]="this.selectedColumns"
                 [value]="users"
                 [lazy]="true"
                 responsiveLayout="scroll"
                 dataKey="Id"
                 (onLazyLoad)="handleLazyLoad($event)"
                 [selection]="selectedUsers"
                 (selectionChange)="onSelectionChange($event)"
                 [paginator]="true"
                 [showFirstLastIcon]="false"
                 [(first)]="first"
                 [rows]="rowsPerPage"
                 [totalRecords]="totalRecords"
                 [resizableColumns]="true"
                 [columnResizeMode]="'expand'"
                 [autoLayout]="true"
                 [styleClass]="'p-datatable-gridlines'"
                 [scrollable]="true"
                 [scrollHeight]="'flex'"
                 [loading]="loading"
                 [style]="{height: 'calc(78vh)'}"
                 [(selection)]="selectedUsers">
            <ng-template pTemplate="caption">
                <div class="onboarding-head">
                    <div class="onboarding-head-title">
                        All Users
                    </div>
                    <div class="flex flex-row finance-head-right">
                        <div class="ml-4" *ngIf="hasAccessToImageManagement">
                            <button pButton pRipple
                                    type="button"
                                    label="Image management"
                                    class="p-button btn-transaction-edit"
                                    (click)="showPopupImageManagement()"></button>
                        </div>
                        <div class="ml-4">
                            <button pButton
                                    icon="pi pi-plus"
                                    class="p-element btn-darkblue p-button p-component"
                                    label="Add User"
                                    (click)="onAddUserClick()"></button>
                        </div>
                        <div class="ml-3 mt-2 mr-2">
                            <column-selector #columnSelector
                                 [defaultColumns]="cols"
                                 (selectedColumnsChange)="onSelectedColumnsChange($event)"
                                 [tableName]="tableName"
                                 [(selectedColumns)]="selectedColumns">
                            </column-selector>
                        </div>
                    </div>
                </div>
            </ng-template>
            <ng-template pTemplate="header">
                <tr>
                    <th *ngFor="let col of this.selectedColumns"
                        [pSortableColumn]="col.field"
                        [pSortableColumnDisabled]="col.disableSort"
                        pResizableColumn
                        [style.width]="col.width">
                        {{col.header}}
                        <p-sortIcon *ngIf="col.showSortIcon" [field]="col.field" class="onboarding-column-sorticon"></p-sortIcon>
                    </th>
                    <th *ngIf="configService.config.showDeleteUser">Action</th>
                </tr>
                <tr>
                    <ng-container *ngFor="let filter of this.selectedColumns">
                        <th class="overflow-unset">
                            <ng-container *ngIf="filter.fieldType === fieldTypeEnum.Inputs">
                                <input type="text" pInputText placeholder="{{filter.placeholder}}" [(ngModel)]="txnHeaderSearch[filter.model]"
                                       (input)="handleFilterChange(filter.field, $event)" />
                            </ng-container>
                            <ng-container *ngIf="filter.fieldType === fieldTypeEnum.InputNumber">
                                <p-inputNumber inputId="integeronly" placeholder="{{filter.placeholder}}" [(ngModel)]="txnHeaderSearch[filter.model]"
                                               (ngModelChange)="handleFilterChange(filter.field, $event)"> </p-inputNumber>
                            </ng-container>
                            <ng-container *ngIf="filter.fieldType === fieldTypeEnum.Dropdown">
                                <ng-container *ngIf="filter.take === 'obj'; else dropdown">
                                    <p-dropdown [options]="filter.options" placeholder="{{filter.placeholder}}"
                                                optionLabel="name" [(ngModel)]="txnHeaderSearch[filter.model]"
                                                (ngModelChange)="onChangeHeaderFilterDropDown(filter.field, $event)"></p-dropdown>
                                </ng-container>
                                <ng-template #dropdown>
                                    <p-dropdown [options]="roles" placeholder="{{filter.placeholder}}"
                                                optionLabel="Name" optionValue="Id" [(ngModel)]="txnHeaderSearch[filter.model]"
                                                (ngModelChange)="onChangeHeaderFilterDropDown(filter.field, $event)"></p-dropdown>
                                </ng-template>
                            </ng-container>
                            <ng-container *ngIf="filter.fieldType === fieldTypeEnum.Calendar">
                                <p-calendar [(ngModel)]="txnHeaderSearch[filter.model]"
                                            [showIcon]="true"
                                            placeholder="{{filter.placeholder}}"
                                            dateFormat="dd M yy"
                                            (ngModelChange)="onChangeHeaderFilterDropDown(filter.field, $event)" />
                            </ng-container>
                            <ng-container *ngIf="filter.fieldType === fieldTypeEnum.CalendarTime">
                                <p-calendar [(ngModel)]="txnHeaderSearch[filter.model]"
                                            [timeOnly]="true"
                                            [showIcon]="true"
                                            hourFormat="12"
                                            placeholder="{{filter.placeholder}}"
                                            (ngModelChange)="onChangeHeaderFilterDropDown(filter.field, $event)" />
                            </ng-container>
                        </th>
                    </ng-container>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-xpressUser let-columns="columns">
                <tr>
                    <td *ngFor="let col of columns" [pSelectableRow]="xpressUser" (click)="handlePopupLinkClick(xpressUser)">
                        {{ xpressUser[col.field] }}
                    </td>
                </tr>
            </ng-template>
            <ng-template pTemplate="paginatorleft" let-state>
                <div *ngIf="users.length > 0" style="padding-left: 10px">
                    Showing {{first + 1}} to {{first + users.length}} of {{totalRecords}} entries
                </div>
            </ng-template>
        </p-table>
    </div>
</div>

<user-management-all-users-details *ngIf="isVisibleUserInfo"
                                   [_selectedUser]="selectedUser"
                                   (changedVisibleUserEmit)="changedVisibleUserEmit($event)">
</user-management-all-users-details>

<p-dialog [(visible)]="showDialogImageManagement"
          [modal]="true"
          [style]="{width: '630px', height: '160px'}"
          [draggable]="false"
          [resizable]="false">
    <ng-template pTemplate="header">
        <span class="discard-header">Image Management</span>
    </ng-template>
    <ng-template pTemplate="body">
        <p-progressBar *ngIf="uploadProgress >= 0"
                       [value]="uploadProgress"
                       [showValue]="true"
                       [style]="{height: '20px'}"
                       class="mb-3 mt-3 pt-3 pb-3">
        </p-progressBar>

        <div class="button-container mt-2">
            <button pButton pRipple
                    type="button"
                    label="1. Archive Folders"
                    [disabled]="isImageManagementButtonDisabled"
                    (click)="archiveFolders()"
                    class="p-button mb-3">
            </button>

            <button pButton pRipple
                    type="button"
                    label="2. Download Latest Archive"
                    [disabled]="isImageManagementButtonDisabled"
                    (click)="downloadLatestArchive()"
                    class="p-button mb-3">
            </button>

            <button pButton pRipple
                    type="button"
                    label="3. Upload Archive File (*.zip)"
                    icon="pi pi-upload"
                    [disabled]="isArchiveFileDisabled"
                    (click)="handleInputClick('idFileInput')"
                    class="p-button mb-3">
            </button>

            <input id="idFileInput"
                   type="file"
                   accept="zip,application/octet-stream,application/zip,application/x-zip,application/x-zip-compressed"
                   style="display: none"
                   (change)="handleArchiveFile($event)"
                   required />

            <button pButton pRipple
                    type="button"
                    label="4. Unpack Archive"
                    [disabled]="isImageManagementButtonDisabled"
                    (click)="unpackLatestArchive()"
                    class="p-button mb-3">
            </button>

            <button pButton pRipple
                    type="button"
                    label="5. ScanAndPopulate. Update Cache"
                    [disabled]="isImageManagementButtonDisabled"
                    (click)="scanAndPopulate()"
                    class="p-button mb-3">
            </button>
        </div>
    </ng-template>
    <ng-template pTemplate="footer">
        <button pButton
                type="button"
                label="Cancel"
                class="p-button-danger mt-4"
                (click)="imageManagementCancel()"></button>
    </ng-template>
</p-dialog>
